// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getSelectAllText} from '../../shared/services/criteria';

const SettlementNoRegistrationDealerCriteria = props => {

    const dealerSelectionMessage = getSelectAllText(props.selectedDealers);

    return (
        <div className='settlement-no-registration-dealer-criteria'>
            <CheckboxListWithLabel
                className='settlement-no-registration-dealers'
                initialState={createHashMap(props.selectedDealers, 'account')}
                isRequired={true}
                label='DEALER_LOCATION'
                list={addCollectionLabels(props.allowedAccounts)}
                onChange={props.onDealerSelect}
                uid='account'
            />
            <button
                className='toggle-all'
                onClick={props.onSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dealerSelectionMessage}/>
            </button>
        </div>);

};

SettlementNoRegistrationDealerCriteria.displayName = 'SettlementNoRegistrationDealerCriteria';
SettlementNoRegistrationDealerCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default SettlementNoRegistrationDealerCriteria;



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/components/settlement-no-registration-dealer-criteria.js